import React, { useState, type FormEvent } from 'react';
import { NumberInput, RadioButtonGroupInput } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { useRateCalculations } from '../hooks/useRateCalculations';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { PARENT_SETTINGS_FIELD } from '../constants';

type Props = {
  source: string;
  inheritedSettings: any;
};

const choices = [
  { id: 'lock_charge_rate', name: 'Lock Charge Rate' },
  { id: 'lock_professional_rate', name: 'Lock Professional Rate' },
];

export const BaseMarginPercentW2LocalInput = ({ source, inheritedSettings }: Props) => {
  const [isLockOptionVisible, setIsLockOptionVisible] = useState(false);
  const { setValue } = useFormContext();
  const { watchedFields, handlers } = useRateCalculations({ source, inheritedSettings });
  const { getValues } = useFormContext();
  const parentSettings = getValues(PARENT_SETTINGS_FIELD);
  const parentSettingsHash = new RateSettingsDisplayHelper({ settings: parentSettings });
  const parentLocalW2Settings = parentSettingsHash.getSettingsForClassification('w2.local');

  function handleLockOptionChange(event: FormEvent<HTMLDivElement>) {
    const value = (event.target as HTMLInputElement).value as
      | 'lock_professional_rate'
      | 'lock_charge_rate';
    handlers.handleLockTypeChange(value);
  }

  return (
    <>
      <NumberInput
        source={`${source}.base_margin_percent_w2`}
        label="Base Margin Percent W2"
        onChange={(event) => {
          if (event.target.value === '') {
            setValue(`${source}.total_margin_percent_w2`, null);

            return;
          }

          const newValue = parseFloat(event.target.value);
          if (!isNaN(newValue)) {
            handlers.handleMarginChange(newValue);
          }
        }}
        onFocus={() => setIsLockOptionVisible(true)}
        helperText={String(
          getInheritedValue(inheritedSettings, 'base_margin_percent_w2', parentLocalW2Settings) ||
            '',
        )}
      />
      {isLockOptionVisible && (
        <RadioButtonGroupInput
          source={`${source}.lockedRateType`}
          choices={choices}
          value={watchedFields.lockedRateType}
          defaultValue="lock_charge_rate"
          label="Calculation Base"
          helperText="Select which rate will be fixed. The other will be automatically calculated based on the entered margin."
          onChange={handleLockOptionChange}
        />
      )}
    </>
  );
};
